import Config from './config.json';

const { GATEWAY_HOST } = Config;

export const API_BASE_URL = `${GATEWAY_HOST}`;
